import { render, staticRenderFns } from "./ContractCommitFeeItem.vue?vue&type=template&id=de32c968&"
import script from "./ContractCommitFeeItem.vue?vue&type=script&lang=js&"
export * from "./ContractCommitFeeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports